module.exports = __webpack_public_path__ + "img/experimentation.0f6705c0.jpeg";